var _ = require('optimizely-client-fn');
var createError = require('core/utils/custom_error').create;
var AsyncRequest = require('core/utils/async_request');
var XHR = require('core/utils/xhr');
var Poll = require('core/utils/poll');
var performanceEnv = require('core/env/performance');
var JSONEnv = require('core/lib/json');
var WindowEnv = require('core/env/window');
var Cookie = require('core/utils/cookie');
var GA4AudienceError = createError('GA4AudienceError');
var Logger = require('core/utils/logger');
var GTMVariableName = 'dataLayer';
var GAVariableName = 'gtag';

function createGA4Error(error) {
    return new GA4AudienceError(error);
}

function getDataLayer() {
  return WindowEnv.getGlobal(GTMVariableName);
}

function getGtagFn () {
  var MAX_RETRIES = 50,
      WAIT_TIME = __TEST__ ? 5 : 200;

  return Poll.pollFor(function() {
    return getGtagFnFromWindow(WindowEnv);
  }, WAIT_TIME, MAX_RETRIES);
}

function getGtagFnFromWindow (window): Function|null {
  var gtagFn = window.getGlobal(GAVariableName);
  if (!gtagFn) {
    return null;
  }
  return gtagFn;
}

function getTagIdValue(item, acc) {
  if(item[0] === 'config') {
    return item[1];
  }
  return acc;
}

function getTagId(dataLayer) {
  const dataLayerList = _.map(dataLayer, function(item) {
    if(_.isArguments(item)) {
      return [].slice.call(item);
    }

    return item;
  });

  return _.reduce(dataLayerList, function(acc, item) {
      return getTagIdValue(item, acc);
  }, '');
}

function getGAClientIdFromGtagFn(gtagFnPromise, tagId, field) {
  return gtagFnPromise.then(function(gtagFn) {
    return new Promise(function(resolve) {
      return gtagFn('get', tagId, field, resolve);
    });
  });
}

function getGA4Audiences(data) {
  if (data && typeof data.audiences === 'string') {
    let audienceString = data.audiences;
    return {
      audiences: audienceString.split(',')
    };
  } else {
    throw createGA4Error('GA4 audience call response is either not defined or not a string: ' + data);
  }
}

function getFullUrl (path, ga4UserId, deviceId) {
  if(!ga4UserId && deviceId) {
    return path + deviceId;
  }

  if(ga4UserId && deviceId) {
    return path + ga4UserId + ',' + deviceId;
  }

  return path + ga4UserId;
}

function fetchGa4Audiences({url, projectId, ga4UserId, ga4DeviceId}) {
  const fullUrl = getFullUrl(url + '?projectId=' + projectId + '&ids=', ga4UserId, ga4DeviceId);

  (__PROFILE__ || __RUM_VERBOSE__) && performanceEnv.time('Ga4audienceCall');

  return XHR.request({
    url: fullUrl,
    contentType: 'application/json',
  })
  .then(
    function (res) {
      (__PROFILE__ || __RUM_VERBOSE__) &&
        performanceEnv.timeEnd('Ga4audienceCall');
      var data;
      if (res.status > 399) {
        // Intentionally swallow response body since it might expose implementation details (AUD-1605)
        throw createGA4Error(res.status + ': ' + res.statusText);
      }

      try {
        data = JSONEnv.parse(res.response);
      } catch (e) {
        throw createGA4Error('Error parsing response: ' + e.toString());
      }

      if (!data) {
        throw createGA4Error('No data received');
      }

      return getGA4Audiences(data);
    },
    function (xhr) {
      (__PROFILE__ || __RUM_VERBOSE__) &&
        performanceEnv.timeEnd('Ga4audienceCall');
      throw createGA4Error(xhr.status + ': ' + xhr.statusText);
    }
  );
}

function callMakeAsyncRequest({source, url, projectId, ga4UserId = null, ga4DeviceId = null}) {
  return AsyncRequest.makeAsyncRequest(source, function () {
    return fetchGa4Audiences({url, projectId, ga4UserId, ga4DeviceId})
    .then(
      function(data){return data;},
      function(error){throw error;})
    .then(
      _.partial(AsyncRequest.resolveRequest, source),
      _.partial(AsyncRequest.rejectRequest, source)
    );
  });
}

function getGACookie() {
  Logger.log('GA4 Audience looking for _ga cookie');
  let myCookie = Cookie.get('_ga', '');
  const regex = /^GA\d\.\d\./;
  if(regex.test(myCookie)) {
    myCookie = myCookie.replace(regex, '');
  }
  Logger.log('GA4 Audience returning value: ' + myCookie);
  return myCookie;
}

module.exports = {
  createGA4Error,
  getDataLayer,
  getGtagFn,
  getTagId,
  getGAClientIdFromGtagFn,
  getFullUrl,
  getGA4Audiences,
  fetchGa4Audiences,
  callMakeAsyncRequest,
  getGACookie
};
